module.exports = {"222424011":"大川街道","222424012":"新民街道","222424013":"长荣街道","222424100":"汪清镇","222424101":"大兴沟镇","222424102":"天桥岭镇","222424103":"罗子沟镇","222424104":"百草沟镇","222424105":"春阳镇","222424106":"复兴镇","222424107":"东光镇","222424200":"鸡冠乡","222424400":"汪清林业局","222424401":"天桥岭林业局","222424402":"大兴沟林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222424.json
// module id = 759
// module chunks = 0